import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { Match, Postponement } from "../interfaces";

interface PostponementDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: Postponement) => void;
  match?: Match;
}

const PostponementDialog: React.FC<PostponementDialogProps> = ({
  open,
  onClose,
  onSave,
  match,
}) => {
  const [teamId, setTeamId] = useState<string | "">(
    match?.postponement?.team ?? ""
  );
  console.log("teamId", teamId, match);
  const [reason, setReason] = useState<string>(
    match?.postponement?.reason ?? ""
  );
  const [newDate, setNewDate] = useState<string>(
    match?.postponement?.new_date ?? ""
  );

  useEffect(() => {
    if (open && match?.postponement) {
      setTeamId(match?.postponement.team ?? "");
      setReason(match?.postponement.reason ?? "");
      setNewDate(match?.postponement.new_date ?? "");
    }
  }, [open, match?.postponement]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Spielverlegung bearbeiten</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <FormControl fullWidth size="small">
            <InputLabel id="postponement-team-label">
              Verlegende Mannschaft
            </InputLabel>
            <Select
              labelId="postponement-team-label"
              value={teamId}
              label="Verlegende Mannschaft"
              onChange={(e) => setTeamId(e.target.value)}
            >
              <MenuItem value="">-- wählen --</MenuItem>
              <MenuItem value={match?.team_home.id}>
                {match?.team_home.name}
              </MenuItem>
              <MenuItem value={match?.team_away?.id}>
                {match?.team_away?.name}
              </MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Grund der Verlegung"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            fullWidth
            size="small"
          />
          <TextField
            label="Neues Datum"
            type="date"
            value={newDate || ""}
            onChange={(e) => setNewDate(e.target.value)}
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Abbrechen
        </Button>
        <Button
          onClick={() =>
            onSave({
              reason,
              new_date: newDate || "",
              team: teamId || "",
            })
          }
          variant="contained"
          color="primary"
          disabled={!teamId || !reason || !newDate}
        >
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PostponementDialog;
